// extracted by mini-css-extract-plugin
var _1 = "QdRvP";
var _2 = "yr_8f";
var _3 = "yXSLd";
var _4 = "DZ1Y6";
export { _1 as "download", _2 as "includedPlugins", _3 as "pluginList", _4 as "title" }
